@if (active | async) {
  <div>
    <ng-content></ng-content>
  </div>
}
